import Plenigo from './Plenigo.js';

window.addEventListener('DOMContentLoaded', () => {
  if (document.documentElement.lang !== 'en-UK') {
    new Plenigo();
  }
});
